import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import { AppDownloadScreen } from "./screens/AppDownloadScreen";
import { E404Screen } from "./screens/E404Screen";
import { FleetaAppDownloadScreen } from "./screens/FleetaAppDownloadScreen";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<E404Screen />} />
        <Route path="/*" element={<E404Screen />} />
        <Route path="/app-download" element={<AppDownloadScreen />} />
        <Route
          path="/fleeta-app-download"
          element={<FleetaAppDownloadScreen />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
